document.addEventListener("globo.formbuilder.form.submitted", (e) => {
  let { form, formId } = e.detail;
  if (formId == "39056") {
    const formData = new FormData(form);
    const result = {};
    formData.forEach((value, key) => {
      if (result[key]) {
        // If already exists, turn it into array
        result[key] = [].concat(result[key], value);
      } else {
        result[key] = value;
      }
    });

    const keyLabel = JSON.parse(result._keyLabel);

    const newResult = {};

    for (const key in result) {
      if (key === "_keyLabel") continue;

      const cleanKey = key.replace(/\[\]$/, "");

      const label = keyLabel[cleanKey];
      if (label) {
        newResult[label] = result[key];
      }
    }

    const newFormData = new FormData();

    const description = `
<body><strong>Choose Your Grip:</strong>
${[].concat(newResult["Choose Your Grip"] || []).join(", ")}

<strong>Choose Your Packaging:</strong>
${[].concat(newResult["Choose Your Packaging"] || []).join(", ")}

<strong>Choose Your Sock Style:</strong>
${[].concat(newResult["Choose Your Sock Style"] || []).join(", ")}

<strong>Company Name:</strong>
${newResult["Company Name"] || ""}

<strong>Email Address:</strong>
<a href='mailto:${newResult["Email Address"]}'>${
      newResult["Email Address"] || ""
    }</a>

<strong>Name:</strong>
${newResult["Name"] || ""}

<strong>Phone Number:</strong>
${newResult["Phone Number"] || ""}

<strong>Website:</strong>
<a href='${newResult["Website"] || ""}'>${newResult["Website"] || ""}</a>

<strong>What colors would you like to see your socks designed in?:</strong>
${newResult["What colors would you like to see your socks designed in?"] || ""}

<strong>What describes you best?:</strong>
${newResult["What describes you best?"] || ""}

This task was submitted through <strong>${result["page[href]"]}</strong>
</body>`;

    newFormData.append("html", description);
    newFormData.append("attachment", newResult["Upload Your Logo"]);

    fetch(
      "http://ethos-merch.clickoapps.com/api/create-task/custom-socks-form-submission",
      {
        method: "POST",
        body: newFormData,
      }
    )
      .then((response) => response.json())
      .then((result) => {
        console.log("Success:", "Form submitted successfully");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
});
